<template>
    <div ref="pageBox">
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px"
                     class="unitWidth" size="small">
                <el-form-item :label="$t('Shift.factory')">
                    <el-select v-model="fcCode" :placeholder="$t('base.PleaseSelect')" :clearable="isclear" :disabled="ischeck" filterable
                               @change="fcChange">
                        <el-option v-for="factory in factoryList" :key="factory.factoryId" :label="factory.fcName"
                                   :value="factory.fcCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.storeName')">
                    <el-select v-model="strCode" :placeholder="$t('base.PleaseSelect')" clearable filterable @change="searchTable">
                        <el-option v-for="house in houseList" :key="house.spsId" :label="house.strName"
                                   :value="house.strCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.receiptType')">
                    <el-select v-model="purchaseType" :placeholder="$t('base.PleaseSelect')" clearable @change="searchTable">
                        <el-option label="采购" value="CG"></el-option>
                        <el-option label="二次利用" value="ST"></el-option>
                        <el-option label="其它" value="SE"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.receiptCode')">
                    <el-input v-model.trim="purchaseCode" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.receiptTime')">
                    <el-date-picker
                        style="width: 50vh"
                        v-model="dateRange"
                        type="daterange"
                        range-separator="-"
                        :start-placeholder="$t('Account.startTime')"
                        :end-placeholder="$t('Account.endTime')" @change="searchTable">
                    </el-date-picker>
                </el-form-item>
                <el-button style="margin-top: 0.3vw" size="small" type="primary" @click="searchTable">{{$t('base.search')}}</el-button>
            </el-form>
        </SearchBox>
        <LabelContent :title="$t('Account.receiptInfo')" ref="LabelContent">
            <div slot="btns">
                <span v-for="acc in access" :key="acc">
                    <el-button size="small" type="success" @click="addPartPurchaseOrder()"
                            v-if="acc == 'WAREHOUSING001'" style="margin-right:10px">{{$t('base.add')}}
                    </el-button>
                </span>
                <el-button size="small" type="success" @click="exportPartPurchase()">{{$t('base.export')}}</el-button>
                <!--                <el-button size="small" type="success" @click=";(record = true),updateToolingRecord()">领用</el-button>-->
                <!--                <el-button size="small" type="warning" @click=";(record = false),updateToolingRecord()">归还</el-button>-->
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center" border
                      @selection-change="handleSelectionChange" @sort-change="sortChange">
                <el-table-column prop="purchaseCode" :label="$t('Account.receiptCode')" width="160"/>
                <el-table-column prop="fcName" :label="$t('Shift.factory')" width="120"/>
                <el-table-column prop="strName" :label="$t('Account.storeName')" width="120"/>
                <el-table-column prop="purchaseOrderCode" :label="$t('Account.purchaseOrderCode')" width="140"/>
                <el-table-column prop="purchaseType" :label="$t('Account.receiptType')" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.purchaseType == 'CG'">采购</span>
                        <span v-if="scope.row.purchaseType == 'ST'">二次利用</span>
                        <span v-if="scope.row.purchaseType == 'SE'">其它</span>
                    </template>
                </el-table-column>
                <el-table-column prop="userName" :label="$t('Account.preparedBy')" width="120"/>
                <el-table-column prop="purchaseDesc" :label="$t('Account.remark')" width="120"/>
                <el-table-column prop="purchaseAmount" sortable :label="$t('Account.price')"/>
                <el-table-column prop="totalPrice" sortable :label="$t('Account.totalPrice')" width="100"/>
                <el-table-column prop="purchaseTime" :label="$t('Account.receiptTime')" width="160"/>
                <el-table-column :label="$t('base.operation')" width="120" fixed="right">
                    <template slot-scope="scope">
                        <i class="document el-icon-document" @click="sparePartPurchaseItem(scope.row)"/>
                        <span v-for="acc in access" :key="acc">
                            <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)"
                            v-if="acc == 'WAREHOUSING002'"/>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
            @size-change="paginationChange"
            @current-change="paginationCurrentChange"
            :current-page="searchParams.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchParams.pageCount"
        />
        <el-dialog :title="$t('Account.receiptRecord')" width="70vw" :visible.sync="purchaseShow" style="text-align: left">
            <el-table stripe ref="multipleTable" :data="partPurchaseItemList" class="center" border>
                <!--<el-table-column prop="purchaseCode" sortable label="入库单号" width="160"/>-->
                <el-table-column prop="spName" sortable :label="$t('Account.spareName')"/>
                <el-table-column prop="spCode" sortable :label="$t('Account.spareCode')"/>
                <el-table-column prop="strName" sortable :label="$t('Account.storeName')"/>
                <el-table-column prop="sppName" sortable :label="$t('Account.locatorName')" width="120"/>
                <el-table-column prop="batchNo" sortable :label="$t('Account.batchNo')"/>
                <el-table-column prop="amount" sortable :label="$t('Account.number')"/>
                <el-table-column prop="spPrice" sortable :label="$t('Account.price')"/>
                <el-table-column prop="totalPrice" sortable :label="$t('Account.totalPrice')"/>
                <el-table-column prop="createTime" sortable :label="$t('Role.createTime')" width="140"/>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import { getAllPartPurchaseOrder } from '../../../libs/api'

    export default {
        name: 'sparePartPurchaseOrder',
        data() {
            return {
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                purchaseShow: false,
                tableData: [],
                factoryList: [],
                houseList: [],
                partPurchaseItemList: [],
                fcCode: '',
                strCode: '',
                purchaseType: '',
                purchaseCode: '',
                dateRange: '',
                userInfo: {},
                role: {},
                ischeck: true,
                isclear: false,
                access: []
            }
        },
        mounted() {
            this.init()
        },
        activated() {
            this.init()
        },
        methods: {
            init() {
                // this.userInfo = sessionStorage.getItem("userInfo")
                this.access = JSON.parse(sessionStorage.getItem('auths'))
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.isclear = true
                        this.role = role[i]
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getAllFactory()
            },
            addPartPurchaseOrder() {
                this.$router.push({
                    name: 'addPartPurchaseOrder'
                })
            },
            sparePartPurchaseItem(row) {
                let params = {
                    purchaseCode: row.purchaseCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.queryPartInfoLogs,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.partPurchaseItemList = response.data
                        this.purchaseShow = true
                    }
                })
            },
            //分页
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.searchTable()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.searchTable()
            },
            //多选框选择 返回当前已选行数据(Array)
            handleSelectionChange(val) {
                console.log(val)
            },
            //从后台获取数据,重新排序
            sortChange(val) {
                // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
                console.log(val)
            },
            deleteRow(row) {
                console.log('row', row)
                this.$confirm(this.$t('msg.TipsText'), this.$t('msg.Tips'), {
                    confirmButtonText: this.$t('base.delete'),
                    cancelButtonText: this.$t('base.cancel'),
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'POST',
                                headers: { 'content-type': 'application/json' },
                                params: { sppoId: row.sppoId },
                                url: this.$api.deletePartPurchaseOrder
                            })
                            .then(response => {
                                this.searchTable()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.searchTable()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.searchTable()
                        this.$message({
                            type: 'info',
                            message: this.$t('msg.cancel')
                        })
                    })
            },
            fcChange() {
                this.strCode = ''
                this.partStoreHouseList()
                this.searchTable()
            },
            getAllFactory() {
                let options = {
                    method: 'get',
                    url: this.$api.getAllFactory
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.factoryList = []
                        var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                        var aa = response.data
                        if (this.ischeck) {
                            for (var i = 0; i < aa.length; i++) {
                                for (let j = 0; j < userInfo.roles.length; j++) {
                                    if (aa[i].factoryId == userInfo.roles[j].factoryId) {
                                        this.factoryList.push(aa[i])
                                        this.fcCode = this.userInfo.fcCode
                                    }
                                }
                            }
                        } else {
                            this.factoryList = response.data
                        }
                    }
                    this.searchTable()
                    this.partStoreHouseList()
                })
            },
            partStoreHouseList() {
                if (this.fcCode == undefined || this.fcCode == '') {
                    return this.houseList = []
                }
                let options = {
                    method: 'get',
                    url: this.$api.partStoreHouseList,
                    params: { fcCode: this.fcCode }
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.houseList = response.data
                    }
                })
            },
            searchTable() {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                if (this.fcCode != undefined && this.fcCode != '') {
                    queryParams['fcCode'] = this.fcCode
                }
                if (this.strCode != undefined && this.strCode != '') {
                    queryParams['strCode'] = this.strCode
                }
                if (this.purchaseType != undefined && this.purchaseType != '') {
                    queryParams['purchaseType'] = this.purchaseType
                }
                if (this.purchaseCode != undefined && this.purchaseCode != '') {
                    queryParams['purchaseCode'] = this.purchaseCode
                }
                if (this.dateRange != null && this.dateRange != '') {
                    if (this.dateRange.length > 0 && this.dateRange[0] != '') {
                        queryParams['startTime'] = this.$moment(this.dateRange[0]).format('YYYY-MM-DD') + ' 00:00:00'
                        queryParams['endTime'] = this.$moment(this.dateRange[1]).format('YYYY-MM-DD') + ' 23:59:59'
                    }
                }
                let options = {
                    method: 'get',
                    url: this.$api.getAllPartPurchaseOrder,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            async exportPartPurchase() {
                let queryParams = {}
                queryParams['language'] = this.$t('lang')
                if (this.fcCode != undefined && this.fcCode != '') {
                    queryParams['fcCode'] = this.fcCode
                }
                if (this.strCode != undefined && this.strCode != '') {
                    queryParams['strCode'] = this.strCode
                }
                if (this.purchaseType != undefined && this.purchaseType != '') {
                    queryParams['purchaseType'] = this.purchaseType
                }
                if (this.purchaseCode != undefined && this.purchaseCode != '') {
                    queryParams['purchaseCode'] = this.purchaseCode
                }
                if (this.dateRange != null && this.dateRange != '') {
                    if (this.dateRange.length > 0 && this.dateRange[0] != '') {
                        queryParams['startTime'] = this.$moment(this.dateRange[0]).format('YYYY-MM-DD') + ' 00:00:00'
                        queryParams['endTime'] = this.$moment(this.dateRange[1]).format('YYYY-MM-DD') + ' 23:59:59'
                    }
                }
                let options = {
                    method: 'POST',
                    params: queryParams,
                    url: this.$api.exportPartPurchase,
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = this.$t('Account.receiptInfo')  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            }
        }
    }
</script>

<style scoped>
</style>
